import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SearchSelect from "components/common/SearchSelect";
import { fetchProvinces } from "api/menu/master-files/locations/actions";

const SelectProvince = ({
                            isClearable,
                            isMultiple,
                            onBlur,
                            provinceId,
                            onChange,
                            fetchProvinces,
                        }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        fetchProvinces(1, (provinces) => {
            setOptions(provinces.map(value => ({
                value: value.id,
                label: value.fullName
            })));
        });
    }, [fetchProvinces]);

    const value = options.find(item => item.value === provinceId) || null;

    return (
        <SearchSelect
            className="custom-react-select"
            isLoading={false}
            isClearable={isClearable}
            isSearchable={true}
            isMulti={isMultiple}
            onBlur={onBlur}
            options={options}
            value={value}
            onChange={items => {
                if (!items) {
                    onChange(isMultiple ? [] : null);
                } else {
                    onChange(items);
                }
            }}
        />
    );
};

const mapStateToDispatch = dispatch => ({
    fetchProvinces: bindActionCreators(fetchProvinces, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(SelectProvince);
